import { Image } from '@chakra-ui/react';
import {
  GatsbyImage,
  GatsbyImageProps,
  IGatsbyImageData,
} from 'gatsby-plugin-image';
import React from 'react';

interface ImageAdapterProps
  extends Omit<GatsbyImageProps, 'description' | 'image' | 'alt'> {
  data:
    | {
        description: string | undefined;
        url: string | undefined;
        gatsbyImageData: IGatsbyImageData | undefined;
      }
    | undefined;
  height?: string;
  maxHeight?: string;
  maxWidth?: string;
}

const ImageAdapter: React.FC<ImageAdapterProps> = ({ data, ...rest }) => {
  if (!data) {
    return null;
  }

  const { description, url, gatsbyImageData } = data;

  if (gatsbyImageData) {
    return (
      <GatsbyImage {...rest} alt={description || ''} image={gatsbyImageData} />
    );
  } else if (url) {
    return <Image {...rest} alt={description || ''} src={url} />;
  }
  return null;
};

export default ImageAdapter;
